module.exports = __webpack_public_path__ + "static/media/squared.2eb37fe6.jpg";